import React, { Component } from 'react';
import GeneralConfigurationItemContainer from '../../investigation/configuration/detail/general/GeneralConfigurationItemContainer';
import FormicaToggleSwitch from '../../custom/FormicaToggleSwitch';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import LanguageUtil from '../../../util/LanguageUtil';
import MessageUtil from '../../../util/MessageUtil';
import { RootState } from '../../../redux/store';
import { ConnectedProps, connect } from 'react-redux';
import { User } from '../../../domain/rbac/RbacDomains';

class WatchlistSettingsComponent extends Component<Props, State> {
  public state = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  public componentDidMount() {
    void this.loadConfig();
  }

  private loadConfig = async () => {
    try {
      const config = await this.watchlistService.getSafeListConfig();
      this.setState({ enabled: config.enabled, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };

  private isAdmin = (): boolean => {
    const { user } = this.props;
    return user.role == 'Admin' || user.role == 'Root' || user.roles.includes('Admin') || (user.groupRoles ?? []).includes('Admin');
  };

  private onToggle = async () => {
    const { enabled, saving } = this.state;
    if (saving || !this.isAdmin()) return;

    const nextValue = !enabled;
    this.setState({ enabled: nextValue, saving: true });
    try {
      await this.watchlistService.saveSafeListConfig(nextValue);
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'pages.watchlist.configuration.title', defaultMessage: 'Watchlist Configuration' }),
        detail: LanguageUtil.get({ id: 'messages.save', defaultMessage: 'Saved' }),
      });
    } catch (e) {
      console.error(e);
      this.setState({ enabled: enabled });
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.configuration.title', defaultMessage: 'Watchlist Configuration' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.configuration.saveError',
          defaultMessage: 'Failed to save Watchlist configuration!',
        }),
      });
    } finally {
      this.setState({ saving: false });
    }
  };

  public render() {
    const { enabled, loading, saving } = this.state;

    if (loading) return null;

    return (
      <div className={'w-full px-5'}>
        <GeneralConfigurationItemContainer
          header={LanguageUtil.get({ id: 'pages.watchlist.safeListConfig.title', defaultMessage: 'Safe List Screening' })}
          description={LanguageUtil.get({
            id: 'pages.watchlist.safeListConfig.description',
            defaultMessage:
              'When this setting is enabled, the search criteria of records added to the Safe List are monitored. If new matches for these criteria are found, a review alert is created even for records already on the Safe List. When the setting is disabled, monitoring is paused; when re-enabled, it resumes from that point with new changes.',
          })}
        >
          <FormicaToggleSwitch large={true} value={enabled} onChange={this.onToggle} disabled={!this.isAdmin() || saving} />
        </GeneralConfigurationItemContainer>
      </div>
    );
  }
}

interface Props extends ReduxProps {}

class State {
  enabled: boolean = false;
  loading: boolean = true;
  saving: boolean = false;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(WatchlistSettingsComponent);
